import { ClientSociety } from "@dune/types";
import { Button, Input } from "@dune/ui";
import { Plus, SearchSm } from "@untitled-ui/icons-react";
import { useState } from "react";
import SelectClientCard from "./SelectClientCard";

import { useDebounce } from "use-debounce";

import { useFormContext } from "react-hook-form";
import { useGetSyndics } from "../../../api/queries/constructionSite.queries";
import { ConstructionSiteDetailsFormData } from "./useConstructionSiteDetailsForm";

type SelectOrCreateSyndicContainerProps = {
	setSelectedSyndic: (client: ClientSociety | null | undefined) => void;
};

const SelectOrCreateSyndicContainer = ({
	setSelectedSyndic,
}: SelectOrCreateSyndicContainerProps) => {
	const [searchInput, setSearchInput] = useState("");
	const [debouncedSearchInput] = useDebounce(searchInput, 500);
	const { data: syndics } = useGetSyndics(debouncedSearchInput);
	const { setValue } = useFormContext<ConstructionSiteDetailsFormData>();
	return (
		<div className="flex flex-col gap-4 w-[70%] border-solid border-1 border-gray-200 rounded-lg  p-4 self-center">
			<div className="flex flex-col border-solid border-1 border-gray-200 rounded-lg p-4 gap-4">
				Rechercher un syndic
				<div className="flex items-center gap-4">
					<Input
						type="text"
						placeholder="SIREN, Raison sociale..."
						onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
							setSearchInput(e.target.value)
						}
						iconOrText={<SearchSm />}
						iconOrTextPosition="right"
					/>
					ou
					<Button
						type="button"
						onClick={() => setSelectedSyndic(null)}
						className="bg-[#038EB7]"
					>
						<Plus />
						Créer un nouveau syndic
					</Button>
				</div>
			</div>
			<div className="flex flex-col rounded-lg gap-4">
				<h2 className="text-[#144C65] text-[18px] font-medium">
					{`${syndics?.length || 0} syndic${syndics?.length > 1 ? "s" : ""} trouvé${syndics?.length > 1 ? "s" : ""}`}
				</h2>
				<div className="grid grid-cols-2 gap-4">
					{syndics?.map((syndic: ClientSociety) => {
						return (
							<SelectClientCard
								key={syndic.siren}
								client={syndic}
								onSelect={(syndic: ClientSociety) => {
									const {
										headOfficeAddress,
										...syndicWithoutHeadOfficeAddress
									} = syndic;
									setSelectedSyndic(syndic);
									setValue("syndicSocietyId", syndic.id);
									setValue("syndicSociety", {
										...syndicWithoutHeadOfficeAddress,
										streetNumber: syndic.headOfficeAddress?.streetNumber ?? "",
										streetName: syndic.headOfficeAddress?.streetName ?? "",
										postalCode: syndic.headOfficeAddress?.postalCode ?? "",
										city: syndic.headOfficeAddress?.city ?? "",
										hasUserAccess: syndic.syndicUserAccessToPlatform
											? "true"
											: "false",
										userAccess: syndic.syndicUserAccessToPlatform
											? {
													lastname: syndic.syndicUserAccessToPlatform.lastname,
													firstname:
														syndic.syndicUserAccessToPlatform.firstname,
													email: syndic.syndicUserAccessToPlatform.email ?? "",
												}
											: undefined,
										hasBrokerageFees: syndic.brokerageFees ? "true" : "false",
										brokerageFees: syndic.brokerageFees?.toString(),
									});
								}}
							/>
						);
					})}
				</div>
			</div>
		</div>
	);
};

export default SelectOrCreateSyndicContainer;
